export default __webpack_public_path__ + "static/media/3insta.c061d164.jpg";